export default __webpack_public_path__ + "static/media/preferences.e8d7eb50.svg";